export default __webpack_public_path__ + "static/media/tablet.8da959b5.svg";